module.exports = __webpack_public_path__ + "static/media/react-logo.bcb37c26.svg";


//////////////////
// WEBPACK FOOTER
// ./public/react-logo.svg
// module id = 309
// module chunks = 0